import dynamic from "next/dynamic";
import { bandFillColor, bandRank, bandStyle, getDataColors, toExposureBand, toRiskBand, type MarkerBand } from "./bands";
import type { ContainerProps as HubMapContainerProps } from "./components/Container";
import * as MapConstants from "./constants";
import { AnalysisPointDetailTab, AnalysisResultsTab, AnalysisView, MapDisplayPoint as HubMapDisplayPoint, RiskiestSettings } from "./types";
import { getRealSizeOfMapBounds } from "./utils/bounds";
import { resolveMarkerBand, resolveMarkerFillColor } from "./utils/markerColor";

/**
 * As react-leaflet doesn't support SSR, we have to dynamically import all map
 * components.
 */
export const HubMapContainer = dynamic(() => import("./components/Container").then(data => data.Container), {
  ssr: false
});
export const HubMapControl = dynamic(() => import("./components/MapControl").then(data => data.MapControl), {
  ssr: false
});
export const HubMapControlBar = dynamic(() => import("./components/MapControl").then(data => data.MapControlBar), {
  ssr: false
});
export const HubMapGeoJsonDisplay = dynamic(() => import("./maps/GeoJsonDisplay"), {
  ssr: false
});
export const HubMapLocationPicker = dynamic(() => import("./maps/LocationPicker"), {
  ssr: false
});
export const HubMapPointsDisplay = dynamic(() => import("./maps/PointsDisplay"), {
  ssr: false
});
export const HubMapPolygonSelector = dynamic(() => import("./maps/PolygonSelector"), {
  ssr: false
});
export const PointMarker = dynamic(() => import("./maps/PointMarker").then(data => data.PointMarker), {
  ssr: false
});
export const PointDetailsPopup = dynamic(() => import("./components/PointDetailsPopup").then(data => data.PointDetailsPopup), {
  ssr: false
});
export type { DataColors } from "./bands";
export { SidebarAdaptedList } from "./components/SidebarAdaptedList";
export { SidebarPointDetails } from "./components/SidebarPointDetails";
export { DEFAULT_SORT_ORDER, SidebarPointList } from "./components/SidebarPointList";
export type { ExposureFilterOption, FilterOption, SortOption, SortOrder } from "./components/SidebarPointList";
export { useDataColors } from "./useDataColors";
export { bandFillColor, bandRank, bandStyle, getDataColors, getRealSizeOfMapBounds, resolveMarkerBand, resolveMarkerFillColor, toExposureBand, toRiskBand };
export type { AnalysisPointDetailTab, AnalysisResultsTab, AnalysisView, HubMapContainerProps, HubMapDisplayPoint, MarkerBand, RiskiestSettings };
export const {
  CLUSTERING_POINT_THRESHOLD,
  MAP_ANIMATION_DURATION,
  MARKER_PANE_LAYER_NAME,
  RATING_COLORS,
  EXPOSURE_COLORS,
  MARKER_STYLE,
  getMarkerStyle,
  POPUP_WIDTH_PX,
  SIDEBAR_WIDTH
} = MapConstants;